module.exports = __webpack_public_path__ + "static/img/cncb-nav.8274827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cncb-nav.png
// module id = 6H9f
// module chunks = 1